import React, { useState } from "react";
import "./withdraw-modal.scss";
import AlertModal from "../Modal";
import WalletWithdrawalSummaryModal from "../WalletWithdrawalSummaryModal/WalletWithdrawalSummaryModal";
import { Icon } from "@material-ui/core";
import { getCurrency, requestIdGenerator } from "../../helpers/Functions";
import { withdrawToBank, withdrawToWallet } from "../../redux/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import { Reducers } from "../../Interfaces/Interfaces";
import { withdrawToBankCoordinator, withdrawWalletCoordinator } from "../../redux/actions/CoordinatorActions";

interface WithdrawProps {
  withdrawType: string;
  detailsTitle: string;
  pin: any;
  setPin: any;

  NewCashout:any;
  PrimaryTheme: any;
  cashout:any;
  cashoutAccount:any;
  account:any;
  setAccount:any
  setAccountName:any
  walletAccount:any
  setWalletAccount:any
  agentName:any
  setAgentName:any
  accountName:any
  submitted:any
  handleSubmit:any
  loading:any
  setLoading: any
  hasCashout:any
  handleBank:any
  handlePinSubmission:any
  authenticate:any
  history:any
  setAmount:any
  amount:any
  validatedEntityId:any
  setAuthenticate:any
  title:any
  subtitle:any
  handleRefresh:any
  setAuthenticationOtp:any
  authenticationOtp:any
  setSubmittedOtp:any
  submittedOtp:any
  counter:any
  setCounter:any
  isCommission:any
  setIsCommission:any
  isBank:any
  setIsBank:any
  loadingCommissionCashout:any
  setLoadingCommissionCashout:any
  isSummary: any
  setIsSummary: any

  borderColor?: string;
  backgroundColor?: string;
  iconColor?: string;
  text?: string;
  className?: "bq-warning" | "bq-info" | "bq-danger" | "bq-success" | undefined;
}

const WithdrawModal = (props: WithdrawProps) => {
  
  const cashout = useSelector((state: Reducers) => state.cashout);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const user = useSelector((state: Reducers) => state.user);  

  return (
    <>
      {!props.isSummary && (
        <AlertModal
          showClose
          maxWidth="xs"
          title={`${props.withdrawType} Withdrawal`}
          blueCloseBtn
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="modal-body-upper-part">
                  <div className="modal-body-upper-part-title">
                    {`${props.withdrawType} balance`}
                  </div>
                  <div className="modal-body-upper-part-amount mb-3">
                    {props.withdrawType=='Wallet'?dashboard?.wallet?.currentBalance==0?'₦0':getCurrency(dashboard?.wallet?.currentBalance):dashboard?.aggregatorCommissionBalance==0?'₦0':getCurrency(dashboard?.aggregatorCommissionBalance)}
                  </div>
                  <div className="modal-body-upper-part-details">
                    <div className="modal-body-upper-part-details-title text-uppercase d-flex justify-content-center">
                      {props.detailsTitle}
                    </div>
                    <div className="modal-body-upper-part-details-body">
                      {props.hasCashout&&props.withdrawType=='Wallet'&&<div>
                        <div className="modal-main-details mb-3">
                          <div className="modal-main-details-title">
                            Bankly account name
                          </div>
                          <div className="modal-main-details-info">
                            {props.withdrawType=='Wallet'?cashout.accountName:user?.businessName}
                          </div>
                        </div>
                        <div className="modal-main-details">
                          <div className="modal-main-details-title">
                            Account number
                          </div>
                          <div className="modal-main-details-info">
                            {props.withdrawType=='Wallet'?cashout.accountNumber:dashboard?.wallet?.nuban}
                          </div>
                        </div>
                      </div>}
                      {props.withdrawType=='Commission'&&<div>
                        <div className="modal-main-details mb-3">
                          <div className="modal-main-details-title">
                            Bankly account name
                          </div>
                          <div className="modal-main-details-info">
                            {user?.businessName}
                          </div>
                        </div>
                        <div className="modal-main-details">
                          <div className="modal-main-details-title">
                            Account number
                          </div>
                          <div className="modal-main-details-info">
                            {dashboard?.wallet?.nuban}
                          </div>
                        </div>
                      </div>}
                      {!props.hasCashout&&<div className="d-flex align-items-start pt-1 pb-2">
                        <img src="/info.svg" alt="" className="pr-2" />
                        <div className="modal-no-account-details-info">
                          Wallet withdrawal account has not been set. Go to settings
                          &gt; Wallet account to setup your withdrawal
                          account.
                        </div>
                      </div>}
                    </div>
                  </div>
                </div>
                <form>
                  <div className="input-wrapper" style={{
                    marginBottom: '10px',
                  }}>
                    <label>Enter amount to withdraw</label>
                    <input
                      type="number"
                      min="0"
                      autoComplete="amount"
                      value={props.amount}
                      disabled={props.withdrawType=='Wallet'&&cashout?.accountNumber==null}
                      // disabled={props.submitted}
                      inputMode="tel"
                      onChange={(e) => props.setAmount(e.target.value)}

                      className="d-block w-100"
                      id="amount"
                      placeholder="0.00"
                      required
                    />
                  </div>
                  {props.withdrawType=='Commission'&&<div style={{
                    display: 'flex'
                  }}>
                    <div className="pr-2 p-0 pt-2">
                      <Icon style={{
                        color: props.iconColor
                      }}>information</Icon>
                    </div>
                    <div
                      style={{
                        paddingTop: '10px',
                        fontSize: '14px'
                      }}
                    >
                      Commissions are withdrawn to your wallet
                    </div>
                  </div>}
                  <button 
                    onClick={props.handlePinSubmission}
                    className="col-12" 
                    disabled={props.amount.length === 0}
                    style={{
                        marginTop: '40px',
                    }}
                  >
                    Continue
                  </button>
                </form>
              </div>
            </div>
          </div>
        </AlertModal>
      )}
      {/* Wallet Withdrawal Summary Modal */}
      { props.isSummary &&
        <WalletWithdrawalSummaryModal 
          pin={props.pin} 
          amount={props.amount} 
          setPin={props.setPin} 
          setLoading={props.setLoading} 
          loading={props.loading} 
          setLoadingCommissionCashout={props.setLoadingCommissionCashout} 
          loadingCommissionCashout={props.loadingCommissionCashout} 
          withdrawalType={props.withdrawType} 
          authenticate={props.authenticate} 
          isSummary={props.isSummary} 
          setIsSummary={props.setIsSummary} 
          handleBank={props.handleBank}
          setAuthenticationOtp={props.setAuthenticationOtp}
          authenticationOtp={props.authenticationOtp}
          submittedOtp={props.submittedOtp}
          setSubmittedOtp={props.setSubmittedOtp}
          validatedEntityId={props.validatedEntityId}
          counter={props.counter}
          setCounter={props.setCounter}
        />
      }
    </>
  );
};

export default WithdrawModal;
